export const environment = {
  production: true,
  buildId: '2959388747919831',
  configFile: 'config.json',
};
